import {mapGetters, mapActions} from 'vuex'
import ApiClientsService from 'js/services/api/api-clients.js'
import ProfileRequestService from 'js/services/api/passenger/profile-requests.js'
import ProfileRequestFormModal from './profile-request-form-modal'
// import ApiProfileRequestsService from 'js/services/api/passenger/profile-requests.js'

import template from './index.pug'

const APPROVED_STATUS = 'approved'

export default {
  template: template(),
  components: {
    ProfileRequestFormModal
  },
  data() {
    const vm = this

    return {
      fields: [
        'Name', 'SurName1', 'SurName2', 'DocumentType', 'RUTPassport', 'Birthday', 'Phone',
        'Address', 'PostalCode', 'Email', 'accredited_profiles'
      ],
      profileData: {
        DocumentType: undefined,
        RUTPassport: undefined,
        Name: undefined,
        SurName1: undefined,
        SurName2: undefined,
        Birthday: undefined,
        Phone: undefined,
        Address: undefined,
        PostalCode: undefined,
        Email: undefined,
        accredited_profiles: undefined
      },
      account: vm.account,
      okProfile: false,
      loadingProfile: false,
      accountLoaded: false,
      showModalForm: false,
      my_profile_requests: []
    }
  },
  computed: {
    ...mapGetters(['showProfileAccreditationRequests'])
  },
  watch: {
    $currentAccount() {
      this.checkIfCanRequestProfile()
    }
  },
  created() {
    this.checkIfCanRequestProfile()
  },
  methods: {
    ...mapActions(['showViewProfileAccreditationRequest']),

    requestProfile() {
      this.showModalForm = true
    },
    closeModalForm() {
      this.showModalForm = false
    },
    viewProfileAccreditationRequests() {
      if (this.my_profile_requests.length < 1) return

      this.showViewProfileAccreditationRequest()
    },
    checkIfCanRequestProfile() {
      const vm = this

      // Tengo cuenta en el municipio actual
      if (vm.$currentAccount) {
        vm.loadingProfile = true

        const params = {
          administrative_area_id: vm.$currentAccount.administrative_area_id,
          rut: vm.$currentAccount.rut
        }

        ApiClientsService.clientMediaInfo(params).then(() => {
          vm.okProfile = true
          vm.getProfile()
        }, () => {
          vm.loadingProfile = false
        })
      }
    },
    getProfile() {
      const vm = this

      if (vm.$currentAccount) {
        const params = {
          administrative_area_id: vm.$currentAccount.administrative_area_id,
          rut: vm.$currentAccount.rut
        }

        ApiClientsService.clientAccount(params).then(client => {
          const data = {}
          _.each(vm.fields, key => {
            data[key] = client[key]
          })
          vm.profileData = data
          vm.loadingProfile = false
          vm.accountLoaded = true
          vm.$currentAccount.Birthday = this.profileData.Birthday
          this.loadMediaProfiles()
        }, () => {
          vm.loadingProfile = false
        })
      }
    },
    loadMediaProfiles() {
      const vm = this
      const params = {
        administrative_area_id: vm.$currentAccount.administrative_area_id,
        rut: vm.$currentAccount.rut,
        document_type: vm.$currentAccount.document_type || 1 //TODO: debería ser el del usuario
      }
      return ProfileRequestService.index(params).then(mp => {
        this.my_profile_requests = mp.data.filter(
          profileRequest => profileRequest.status !== APPROVED_STATUS
        )
      })
    }
  }
}
